const devices = {
  mobile: '(min-width: 30em)',
  tablet: '(min-width: 48em)',
};

export default devices;
